import React, { Component, useState, useMemo, Fragment, useImperativeHandle, forwardRef, waitFor } from "react";
import DefaultDataGrid from './DefaultDataGrid';
import { Stack } from '@mui/system';
import { Grid, TextField, Typography, Tabs, Tab, Button, IconButton, Divider, Chip, Tooltip } from '@mui/material';
import AutocompleteText from "./AutocompleteText";
import InputColumn from './InputColumn'
import { Plus, Trash } from 'tabler-icons-react';

function TabPanel(props) {
    return props.index == props.value && <Grid xs item>
        {props.children}
    </Grid>;
}
const StyledTab = (props) => <Tab  {...props} sx={{
    '&.MuiButtonBase-root': {
        borderRadius: "10px",
        padding: "0 5px 0 5px",
    },
    '&.Mui-selected': {
        "backgroundColor": "transparent",
        border: "none",
    }
}} />

class TabManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = { page: 0, loading: false };
    }
    setPage = (index, callback) => this.setState({ page: index }, callback);
    getPage = () => this.state.page;
    render() {
        const props = this.props;
        return (<Grid xs={12} item container marginBottom={"20px"} alignItems="center" justifyContent="center" >
            <Grid xs={props.handleTabAdd ? 11 : 12} item className="container" marginBottom={"20px"}>
                {props.title && (
                    <Typography variant="h6" textAlign="left">
                        {props.title}
                    </Typography>
                )
                }
                <Tabs TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
                    variant="scrollable"
                    scrollButtons={true}
                    value={this.state.page} onChange={(e, v) => this.setPage(v)} aria-label="basic tabs example">
                    {
                        props.children.map((e, index) =>
                            <StyledTab
                                label={<Chip label={e.props.tablabel} sx={{ borderRadius: "10px" }}
                                    onDelete={props.handleTabDelete ? () => props.handleTabDelete(e.props.index) : undefined} key={`tabChip.${e.props.index}`} />}
                                key={`tab.${e.props.index}`} />
                        )
                    }
                </Tabs>
            </Grid>
            {
                props.handleTabAdd && <Grid xs={1} item >
                    <Tooltip title="Dodaj" ><IconButton onClick={props.handleTabAdd} style={{ color: "black" }} ><Plus /></IconButton ></Tooltip>
                </Grid>
            }
            <Grid xs={12} item>
                {
                    props.children.map(e => {
                        //console.log(e)
                        return (
                            <TabPanel value={this.state.page} index={e.props.index} key={`tabPanel.${e.props.index}`}>
                                {e}
                            </TabPanel>
                        )
                    }
                    )
                }
            </Grid>
        </Grid>)
    }
}
export default TabManager;